import { streem } from 'streem-sdk-protobuf';
import { statusOptions, StatusOptionValueType } from '../status_option_value';

const AvailabilityStatus = streem.api.AvailabilityStatus;

export const defaultNotAvailableOption: Readonly<StatusOptionValueType> = statusOptions.find(
    option => option.value.keyArray.includes(AvailabilityStatus.AVAILABILITY_STATUS_NOT_AVAILABLE),
);
